<template lang="pug">
validation-observer(ref="observer", tag="div")
  app-divider(label="Dados do outorgante").mb-30px
  el-row.labelDiv(:gutter="30", justify="space-between")
    el-col
      el-radio-group(
        :value="outorgante.pessoa.tipo",
        @change.native="clearDocumentos"
      )
        el-radio(
          label='PF'
        ) Pessoa Física
        el-radio(
          label='PJ'
        ) Pessoa Jurídica
  el-row.labelDiv.mt-10px(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Nome/Razão Social'")
        app-label(:label="outorgante.pessoa.tipo === 'PF' ? 'Nome:': 'Razão Social:'", :required="true")
        el-input.input(
          name="nome"
          v-model="nomeRazaoSocial",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="16")
      validation-provider(rules="required|cpf_cnpj", v-slot="{ errors }", :name="nomeAba + '/CPF/CNPJ'")
        app-label(:label="outorgante.pessoa.tipo === 'PF' ? 'CPF:': 'CNPJ:'", :required="true")
        el-input.input(
          name="cpf"
          v-mask="'###.###.###-##'"
          v-model="cpfCnpj",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  div(v-if="outorgante.pessoa.tipo === 'PF'")
    el-row.labelDiv.mt-10px(:gutter="30")
      el-col.inputDiv(:span="8")
        app-label(label="RG:", :required="false")
        el-input.input(
          name="rg"
          v-model="outorgante.pessoa.pessoaFisica.rg",
        )
      el-col.inputDiv(:span="8")
        app-label(label="Órgão Expedidor: ", :required="false")
        el-select.input(
          name='Órgão expedidor'
          class="select",
          size="large",
          no-match-text="Nenhum orgão encontrado",
          placeholder="Selecione",
          v-model="outorgante.pessoa.pessoaFisica.orgaoExpedidor.nome"
          @change="setOrgaoCodigo"
          value-key="id"
          filterable,
          clearable,
        )
          el-option(
            v-for="orgaoExpedidor in orgaosExpedidores",
            :key="orgaoExpedidor.id",
            :label="orgaoExpedidor.nome",
            :value="orgaoExpedidor.nome"
          )
      el-col.inputDiv(:span="8")
        app-label(label="UF do Órgão Expedidor:", :required="false")
        el-select.input(
          v-model="outorgante.pessoa.pessoaFisica.orgaoExpedidor.estado"
          size="large",
          placeholder="Selecione"
        )
          el-option(
            v-for="estado in estadosBr",
            :key="estado.codigo",
            :label="estado.nome",
            :value="estado.codigo"
          )
    el-row.labelDiv.mt-10px(:gutter="30")
      el-col.inputDiv(:span="8")
        validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Data de Nascimento'")
          app-label(label="Data de nascimento:", :required = "true")
          el-date-picker.input.full-width(
            type="date",
            size="large",
            name='Data de nascimento'
            v-model="outorgante.pessoa.pessoaFisica.dataNascimento",
            v-mask="'##/##/#####'",
            placeholder="Selecione",
            format="dd/MM/yyyy",
            :picker-options="pickerOptions",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
      el-col.inputDiv(:span="8")
        validation-provider(rules="required|email", v-slot="{ errors }", :name="nomeAba + '/Email'")
          app-label(label="Email:", :required="true")
          el-input.input(
            name="email"
            type="email"
            v-model="outorgante.pessoa.email",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
      el-col.inputDiv(:span="8")
        app-input-telefone(
          :telefones="outorgante.pessoa.telefones",
          :nomeAba="nomeAba",
          :requiredTelefones="true"
          :observer="this.$refs.observer"
        )
  el-row.labelDiv
    app-endereco(:endereco="outorgante.pessoa.endereco", nomeAba="Outorgante", titulo="Endereço do outorgante")
  el-row(v-if="documentos")
    app-documentos(
      :maxSize='25',
      :valid-extensions="['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png']",
      :documentos="outorgante.documentos"
      :tiposDocumentos="documentosOutorgantePessoa"
      :tiposDocumentosObrigatorios="documentosObrigatorio"
      :observer="this.$refs.observer",
      aba="Outorgante",
      titulo="Documentos do outorgante"
    )
</template>

<script>
import AppEndereco from '@/components/AppEndereco'
import estadosBr from '@/constants/estados'
import AppLabel from '@/components/AppLabel'
import AppInputTelefone from '@/components/AppInputTelefone'
import empty from '@/screens/central/cadastros/default/empty/emptyRf'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import AppDocumentos from '@/screens/central/components/cadastro/AppDocumentos'
import AppDivider from '@/components/AppDivider.vue'
import { mapActions, mapGetters } from 'vuex'

export default {

  props: {
    jsonCadastro: {
      type: Object
    },
    isProcessoFisico: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  mixins: [
    AppNotificacao
  ],

  components: {
    AppEndereco,
    AppLabel,
    AppInputTelefone,
    AppDocumentos,
    AppDivider
  },

  data () {
    return {
      nomeAba: 'Outorgante',
      orgaosExpedidores: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      estadosBr,
      documentos: [],
      documentosObrigatorio: []
    }
  },

  async created () {
    this.setOrgaosExpeditores()
    this.documentos = await this.findDocumentos('outorganteCadastroRf')
  },

  methods: {
    ...mapActions({
      getOrgaosExpedidores: 'orgaosExpedidores/getItems',
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    }),

    setOrgaoCodigo () {
      this.outorgante.pessoa.pessoaFisica.orgaoExpedidor.codigo = this.orgaosExpedidores.find(
        orgao => orgao.nome === this.outorgante.pessoa.pessoaFisica.orgaoExpedidor.nome
      ).codigo
    },

    async setOrgaosExpeditores () {
      this.orgaosExpedidores = await this.getOrgaosExpedidores()
      if (this.isProcessoFisico) {
        this.orgaosExpedidores.forEach(element => {
          element.nome = element.nome.toUpperCase()
        })
      }
    },

    clearDocumentos (event) {
      this.confirmBox('Ao alterar o tipo de pessoa você perderá os dados preenchidos. Deseja confirmar?', this.$messages.TITULO_WARNING,
        async () => {
          this.outorgante.pessoa.telefones = []
          this.outorgante.pessoa.email = null
          this.outorgante.pessoa.tipo = event.target.value
          if (this.outorgante.pessoa.tipo === 'PF') {
            this.outorgante.pessoa.pessoaFisica.telefones = []
            this.outorgante.pessoa.pessoaFisica = empty.json.pessoa.pessoaFisica
          } else {
            this.outorgante.pessoa.pessoaJuridica = empty.json.pessoa.pessoaJuridica
            this.outorgante.pessoa.pessoaJuridica.telefones = []
          }
          this.outorgante.documentos = []
        },
        () => {
        }, 'Sim', 'Não')
    },
    async validate () {
      // workaround para contornar problema na validação do componente de telefone
      delete this.$refs.observer.refs['$ignoreTelefone$']

      return this.$refs.observer.validate()
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    }),

    outorgante () {
      return this.jsonCadastro.interessado
    },

    cpfCnpj: {
      get () {
        return this.outorgante.pessoa.cpfCnpj
      },
      set (value) {
        this.outorgante.pessoa.cpfCnpj = value

        if (this.outorgante.pessoa.tipo === 'PF') {
          this.outorgante.pessoa.pessoaFisica.cpf = value
        } else {
          this.outorgante.pessoa.pessoaJuridica.cnpj = value
        }
      }
    },
    documentosOutorgantePessoa () {
      if (this.outorgante.pessoa.tipo === 'PF') {
        return this.documentos
          .filter(d => ['IDENTIFICACAO_INTERESSADO', 'CPF_INTERESSADO', 'COMPROVANTE_RESIDENCIA_INTERESSADO', 'OUTROS'].includes(d.codigo))
      } else {
        return this.documentos
          .filter(d => ['CNPJ_INTERESSADO', 'CONTRATO_SOCIAL_NAO_ONEROSO', 'INSCRICAO_ESTADUAL',
            'IDENTIFICACAO_PROCURADOR', 'CPF_PROCURADOR', 'OUTROS'].includes(d.codigo))
      }
    },
    nomeRazaoSocial: {
      get () {
        return this.outorgante.pessoa.nomeRazaoSocial
      },
      set (value) {
        this.outorgante.pessoa.nomeRazaoSocial = value

        if (this.outorgante.pessoa.tipo === 'PF') {
          this.outorgante.pessoa.pessoaFisica.nome = value
        } else {
          this.outorgante.pessoa.pessoaJuridica.razaoSocial = value
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }
  .inputDiv {
    width: 100%;
  }
}

.mt-10px {
  margin-top: 10px;
}

.input {
  width: 100%;
}
.mb-30px {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/cadastroRf/AppFormularioOutorgante.vue